import classNames from 'classnames';
import * as React from 'react';
import styles from './ButtonScroll.module.scss.js';

function ButtonScroll(_a) {
    var _b, _c;
    var isHideIconScroll = _a.isHideIconScroll, onClick = _a.onClick, size = _a.size, _d = _a.direction, direction = _d === void 0 ? 'down' : _d, _e = _a.className, className = _e === void 0 ? '' : _e;
    var iconMouse = '';
    var iconArrow = '';
    switch (size) {
        case 'large':
            iconMouse = classNames(styles.iconMouse, styles.large);
            iconArrow = classNames(styles.iconArrow, styles.large);
            break;
        case 'medium':
            iconMouse = classNames(styles.iconMouse, styles.medium);
            iconArrow = classNames(styles.iconArrow, styles.medium);
            break;
        case 'small':
            iconMouse = classNames(styles.iconMouse, styles.small, styles.correctPosition);
            iconArrow = classNames(styles.iconArrow, styles.small);
            break;
        default:
            iconMouse = classNames(styles.iconMouse);
            iconArrow = classNames(styles.iconArrow);
    }
    return (React.createElement("div", { className: classNames(styles.icon, (_b = {}, _b[styles.isHide] = isHideIconScroll, _b), (_c = {}, _c[className] = className !== '', _c)), onClick: onClick },
        direction === 'up' && React.createElement("div", { className: classNames(iconArrow, styles.directionUp) }),
        React.createElement("div", { className: iconMouse }),
        direction === 'down' && React.createElement("div", { className: iconArrow })));
}
var ButtonScroll$1 = React.memo(ButtonScroll);

export { ButtonScroll$1 as default };
//# sourceMappingURL=ButtonScroll.js.map
